import { render, staticRenderFns } from "./ListagemProdutos.vue?vue&type=template&id=67763e3c&"
import script from "./ListagemProdutos.vue?vue&type=script&lang=js&"
export * from "./ListagemProdutos.vue?vue&type=script&lang=js&"
import style0 from "./ListagemProdutos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports